import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import InstallerPortal from "./pages/InstallerPortal.jsx";
import TechApp from "./pages/TechApp.jsx";
import {
  initInstallPrompt,
  isNativeApp,
  registerServiceWorker,
} from "./pwa/pwa.js";
import "./index.css";

// Roteamento simples por pathname.
//   /installer → Portal do Técnico (Sprint 5.2B — AP do Sonoff)
//   /tech      → App Técnico mobile / PWA (Sprint 6.2 / 6.3)
//   outras     → NOC normal
//
// Sprint 6.3 — quando embrulhado pelo Capacitor (app nativo
// Android/iOS), o app abre SEMPRE no App Técnico, qualquer que
// seja o pathname inicial carregado pelo WebView.
const path = window.location.pathname.replace(/\/+$/, "");
const native = isNativeApp();

function pick() {
  if (native) return <TechApp />;
  if (path === "/installer") return <InstallerPortal />;
  if (path === "/tech") return <TechApp />;
  return <App />;
}

// PWA. O service worker e o prompt de instalação só atuam no /installer
// web (ver pwa.js); o NOC não vira PWA, e o app nativo não usa SW. O
// atalho iOS/Android do Portal do Instalador abre /installer (start_url
// do manifest) — não cai mais no legado /tech.
initInstallPrompt();
if (path === "/installer" && !native) {
  window.addEventListener("load", () => {
    registerServiceWorker();
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {pick()}
  </React.StrictMode>
);
